<template>
  <div>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.smAndUp"
      color="primary"
      app
      :height="NAVBAR_HEIGHT"
      fixed
      :clipped-right="$vuetify.breakpoint.smAndUp"
      :hide-on-scroll="scrollOffNavbarEnabled"
    >
      <!-- hamburger icon for activing sidebar drawer -->
      <v-app-bar-nav-icon dark @click.stop="toggleSideBar"></v-app-bar-nav-icon>
      <v-spacer v-if="$vuetify.breakpoint.xs"></v-spacer>
      <!-- Application logo -->
      <!-- Small screen -->
      <v-toolbar-title class="pl-1 ml-0 c-toolbar">
        <v-layout row justify-center v-if="$vuetify.breakpoint.xs">
          <v-flex xs3>
            <v-avatar tile width="90px">
              <v-img
                :src="require(`@/assets/engie-logo.svg`)"
                alt="Engie"
              ></v-img>
            </v-avatar>
          </v-flex>
        </v-layout>
        <!-- Large screen -->
        <v-avatar tile v-else class="ml-0" width="90px">
          <v-img
            :src="require(`@/assets/engie-logo.svg`)"
            alt="Engie"
            height="32"
          ></v-img>
        </v-avatar>
      </v-toolbar-title>
      <div class="caption info--text">v{{ version }}</div>
      <div v-if="gitBranch !== 'master'" class="caption info--text">
        [{{ gitBranch }}]
      </div>
      <v-spacer></v-spacer>
      <!-- Rigth menu for small screen-->
      <v-menu
        offset-y
        origin="center center"
        :nudge-bottom="10"
        transition="slide-y-transition"
        :min-width="180"
        v-if="$vuetify.breakpoint.xs"
      >
        <v-btn icon>
          <v-icon>more_vert</v-icon>
        </v-btn>
        <c-setting-list></c-setting-list>
      </v-menu>
      <v-toolbar-items class="mr-0" v-if="!$vuetify.breakpoint.xs">
        <!-- entities search selector -->

        <c-entities-selector></c-entities-selector>
        <!-- End entities selector -->
        <!-- Notifications menu -->
        <c-notification-list />
        <v-menu
          offset-y
          origin="center center"
          :nudge-bottom="10"
          transition="slide-y-transition"
          :min-width="58"
        >
          <template v-slot:activator="{ on }">
            <v-btn text small class="c-button-toolbar" v-on="on">
              <v-avatar size="30px" color="grey lighten-4">
                <img src="@/assets/avatar.png" alt="Profil Setting" />
              </v-avatar>
            </v-btn>
          </template>
          <c-setting-list></c-setting-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
import CentitiesSelector from '@/components/widgets/CustomEntitiesMenuSelector';
import CNotificationList from '@/components/widgets/NotificationList';
import CSettingList from '@/components/widgets/SettingList';
import { mapGetters } from 'vuex';
import { generateMessage } from '@/utils/i18n';
import NAVBAR_HEIGHT from '@/components/boilerplate/NavBar/navBar.styles';

export default {
  name: 'c-toolbar',
  components: {
    CNotificationList,
    CSettingList,
    'c-entities-selector': CentitiesSelector,
  },
  data() {
    return {
      entitiesSelectorOpen: false,
      NAVBAR_HEIGHT,
      version: 0,
      gitBranch: '',
    };
  },
  computed: {
    ...mapGetters({
      scrollOffNavbarEnabled: 'boilerplate/scrollOffNavbarEnabled',
      entities: 'entities/current',
    }),
  },
  mounted() {
    this.version = process.env.PACKAGE_VERSION;
    this.gitBranch = process.env.CI_COMMIT_BRANCH;
  },
  methods: {
    removeSelectedEntities(item) {
      const index = this.entities.findIndex((el) => el === item);
      const newEntities = [...this.entities];
      newEntities.splice(index, 1);
      this.$store.dispatch('entities/setCurrent', newEntities);
    },
    toggleSideBar() {
      this.$store.dispatch('boilerplate/toggleSideBar');
    },
    generateMessage,
  },
};
</script>
<style scoped>
#appDrawer.drawer-menu--scroll {
  height: calc(100vh - 158px);
  overflow: auto;
}
.c-toolbar {
  width: 233px; /* aside_width - toolbar_icon_width*/
  font-size: 16px;
  height: 100%;
  padding: 6px;
}
.c-img {
  height: 40px;
  width: 58px !important;
}
.c-search {
  min-width: 350px;
}
.c-button-toolbar {
  min-width: 65px !important;
}
/* On screens that are between 720 and 600px  */
@media screen and (min-width: 600px) and (max-width: 720px) {
  .c-search {
    min-width: 280px;
  }
}
/* On screens that are between 900 and 600px  */
@media screen and (min-width: 600px) and (max-width: 850px) {
  .c-toolbar {
    width: 95px;
  }
}
.c-search-entities-select {
  margin: auto;
  border: 1px solid rgb(224, 224, 224);
  border-radius: 5px;
}
</style>
<style scoped>
.v-select__slot label {
  left: 0;
  right: auto;
  position: inherit !important;
}
</style>
